import React from "react";

export default function EliminarDados() {
  return (
    <section className="container py-4">
      <h1>Eliminar Dados de Conta</h1>
      <p>Se iniciou sessão com Facebook/Google/Apple, pode:</p>
      <ol>
        <li>Remover o acesso do aplicativo nas definições da sua conta (ex.: Facebook &gt; Settings &gt; Apps &amp; Websites).</li>
        <li>Solicitar remoção manual enviando email para <a href="mailto:info@lucianacosta.cv">info@lucianacosta.cv</a>.</li>
      </ol>
      <p>
        Para pedidos vindos do Facebook, pode também usar o nosso endpoint automático de remoção. Estado do pedido:{" "}
        <code>/facebook/deletion-status?code=...</code>
      </p>
    </section>
  );
}
